import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Classes, Dialog, Divider
} from '@blueprintjs/core';

type Props = {
  title: string,
  description: string,
  isJurisdictionAreaDialogOpen: boolean,
  accessFunctionsList: string[],
  handleClose: () => void,
}

export const COLLECTION_FUNCTION_GROUP_I18N_KEY = 'jurisdictionArea.dialog';

export const JurisdictionAreaDialog = ({
  isJurisdictionAreaDialogOpen,
  accessFunctionsList,
  title,
  description,
  handleClose,
}: Props) => {

  const { t } = useTranslation();

  const renderAccessFunctions = () => {
    return accessFunctionsList.map((accessFunction, index) => {
      return (
        <div key={index}>
          <div className="jurisdiction-area-access-function-update-failed">{accessFunction}</div>
          {index !== (accessFunctionsList.length - 1) ? <Divider /> : null}
        </div>
      )
    });
  }

  return (
    <Dialog
      title={title}
      isOpen={isJurisdictionAreaDialogOpen}
      onClose={() => handleClose()}
    >
      <div className={Classes.DIALOG_BODY}>
        <div>{description}</div>
        <div className="jurisdiction-area-access-function">{renderAccessFunctions()}</div>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            intent="primary"
            onClick={() => handleClose()}
          >
            {t('common.button.ok')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default JurisdictionAreaDialog;
